import { render, staticRenderFns } from "./SideBarProjectUpdates.vue?vue&type=template&id=38ae2c58&scoped=true&"
import script from "./SideBarProjectUpdates.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBarProjectUpdates.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ae2c58",
  null
  
)

export default component.exports